import { ArrowUpRight, Smartphone } from "lucide-react";
import { WHATSAPP } from "./Nav";
import SocialIcons from "./SocialIcons";

export default function CTA() {
    return (
        <section
            id="contact"
            data-testid="cta-section"
            className="relative py-28 md:py-40 overflow-hidden"
        >
            <div className="ink-blot top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[60rem] opacity-40" />

            <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-center">
                    {/* Left — headline & primary actions */}
                    <div className="md:col-span-8 reveal">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-7">
                            ⎯⎯ §07 · The Next Move
                        </div>
                        <h2
                            data-testid="cta-headline"
                            className="font-serif-display text-[clamp(2.8rem,8vw,8rem)] leading-[0.92] tracking-tighter text-balance"
                        >
                            Ready to engineer{" "}
                            <span className="italic text-[#e6192b]">
                                authority
                            </span>
                            ?
                        </h2>
                        <p className="mt-8 max-w-xl text-[#a0a0ab] leading-relaxed">
                            A 30-minute discovery call. No deck-shoving.
                            We&apos;ll diagnose your narrative gap, map a GEO
                            opportunity, and tell you — honestly — whether
                            we&apos;re the right partner.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
                            <a
                                href={WHATSAPP}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="cta-primary-discovery-call"
                                className="group inline-flex items-center gap-3 bg-[#e6192b] hover:bg-[#ff2a3d] text-white px-8 py-4 rounded-full text-[12px] uppercase tracking-[0.22em] font-medium transition-all hover:scale-[1.02] w-fit"
                            >
                                Book a Discovery Call
                                <ArrowUpRight
                                    size={16}
                                    className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                />
                            </a>
                            <a
                                href="mailto:contact@pixelgrok.com"
                                data-testid="cta-email"
                                className="text-[12px] uppercase tracking-[0.22em] text-[#a0a0ab] hover:text-white red-link transition-colors w-fit"
                            >
                                or write — contact@pixelgrok.com
                            </a>
                        </div>

                        {/* Socials */}
                        <div className="mt-12 pt-8 border-t border-[#26262a] flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">
                            <span className="text-[11px] uppercase tracking-[0.22em] text-[#a0a0ab]">
                                ⎯⎯ Or follow the studio
                            </span>
                            <SocialIcons size="md" variant="ghost" />
                        </div>
                    </div>

                    {/* Right — WhatsApp QR card */}
                    <div className="md:col-span-4 reveal">
                        <a
                            href="https://wa.me/message/TNOQZLHDIQ4LI1"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="cta-qr-card"
                            aria-label="Scan to chat on WhatsApp"
                            className="group block relative border border-[#26262a] hover:border-[#e6192b] bg-[#0a0a0c] p-6 md:p-7 transition-colors duration-500"
                        >
                            {/* Top bar */}
                            <div className="flex items-center justify-between mb-5">
                                <span className="text-[10px] uppercase tracking-[0.3em] text-[#e6192b] flex items-center gap-2">
                                    <span className="h-1.5 w-1.5 rounded-full bg-[#e6192b] blink" />
                                    Scan · WhatsApp
                                </span>
                                <Smartphone
                                    size={16}
                                    strokeWidth={1.4}
                                    className="text-[#a0a0ab] group-hover:text-[#e6192b] transition-colors"
                                />
                            </div>

                            {/* QR */}
                            <div className="relative aspect-square bg-[#050505] border border-[#26262a] overflow-hidden">
                                <img
                                    src="/whatsapp-qr.png"
                                    alt="WhatsApp QR — Pixelgrok Media"
                                    loading="lazy"
                                    decoding="async"
                                    className="absolute inset-0 w-full h-full object-contain transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                {/* Cinematic corner brackets */}
                                <span className="absolute top-2 left-2 w-3 h-3 border-t border-l border-[#e6192b]" />
                                <span className="absolute top-2 right-2 w-3 h-3 border-t border-r border-[#e6192b]" />
                                <span className="absolute bottom-2 left-2 w-3 h-3 border-b border-l border-[#e6192b]" />
                                <span className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-[#e6192b]" />
                            </div>

                            {/* Caption */}
                            <div className="mt-5 flex items-baseline justify-between gap-3">
                                <div>
                                    <div className="font-serif-display text-xl md:text-2xl leading-tight">
                                        Talk now,{" "}
                                        <span className="text-[#e6192b]">
                                            on WhatsApp
                                        </span>
                                        .
                                    </div>
                                    <div className="mt-1 text-[11px] uppercase tracking-[0.22em] text-[#a0a0ab]">
                                        +91 97391 91933
                                    </div>
                                </div>
                                <ArrowUpRight
                                    size={18}
                                    className="text-[#a0a0ab] group-hover:text-[#e6192b] transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 flex-shrink-0"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
